import React from 'react';
import { Navbar } from '../../components';
import { ChartDocHeader } from '../../containers';

const ChartDoc = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <ChartDocHeader />
        </div>
    </div>
  )
}

export default ChartDoc